import Vue from "vue";
import Router from "vue-router";
// import { Store } from "vuex";
Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [{
            path: "/",
            name: "home",
            props: true,
            component: () =>
                import ("./../src/components/LandingPage.vue"),
        },
        {
            path: "/contactUs",
            name: "ContactUs",
            props: true,
            component: () =>
                import ("./../src/components/ContactUs/contactUs"),
        },
        {
            path: "/coursesPage",
            name: "CoursesPage",
            props: true,
            component: () =>
                import ("./../src/components/Courses/coursesPage"),
        },
        {
            path: "/courseDetails",
            name: "courseDetails",
            props: true,
            component: () =>
                import ("./../src/components/Courses/courseDetails"),
        },
        {
            path: "/techDetails",
            name: "techPage",
            props: true,
            component: () =>
                import ("./../src/components/TechPage.vue"),
        },
        {
            path: "/ourPartners",
            name: "ourPartners",
            props: true,
            component: () =>
                import ("./../src/components/OurPartners.vue"),
        },
        {
            path: "/ourStory",
            name: "ourStory",
            props: true,
            component: () =>
                import ("./../src/components/OurStory.vue"),
        },
        {
            path: "/ourFeilds",
            name: "ourFeilds",
            props: true,
            component: () =>
                import ("./../src/components/OurFields.vue"),
        },
        {
            path: "/clients",
            name: "clients",
            props: true,
            component: () =>
                import ("./../src/components/ClientsPage.vue"),
        },
        {
            path: "/aiPage",
            name: "aiPage",
            props: true,
            component: () =>
                import ("./../src/components/AiPage.vue"),
        },
        {
            path: "/ourWorksHome",
            name: "ourWorksHome",
            props: true,
            component: () =>
                import ("./../src/components/OurWorks.vue"),
        },
        {
            path: "/blogs",
            name: "blogs",
            props: true,
            component: () =>
                import ("./../src/components/BlogsPage.vue"),
        },




    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },

});



// router.beforeEach((to, from, next) => {
//   if (
//     to.matched.some((route) => route.meta.requiresAuth == true) &&
//     store.state.isLoggedIn == false
//   ) {
//     console.log(from);
//     next({ name: "login", params: { lastPage: from } });
//     return;
//   }


//   next();
// });

export default router;